import {config, http} from './__http';

export default {

    getCouponOptions(coupons, params) {
        http.get(config.baseUrl()+'/coupon').then(response => {
            coupons(response.data)
        }).catch(e => {
            console.error(e);
        });
    },
    getCoupon(coupon, id) {
        http.get(config.baseUrl()+'/coupon/'+id).then(response => {
            coupon(response.data);
        }).catch(e => {
            console.error(e);
        });
    },
    createCoupon(coupon, params) {
        http.post(config.baseUrl()+'/coupon', params).then(response => {
            coupon(response.data);
        }).catch(e => {
            coupon(e.response);
        });
    },
    updateCoupon(coupon, params) {
        http.put(config.baseUrl()+'/coupon/'+params.Id, params).then(response => {
            coupon(response.data);
        }).catch(e => {
            coupon(e.response);
        });
    },
    submitCouponCode(coupon, params) {
        http.post(config.baseUrl()+'/coupon/check', params).then(response => {
            coupon(response.data);
        }).catch(e => {
            coupon(e.response);
        });
    }
}


// WEBPACK FOOTER //
// ./src/api/Coupon.js